import { render } from "./ProviderPage.vue?vue&type=template&id=090e499e&scoped=true"
import script from "./ProviderPage.vue?vue&type=script&lang=js"
export * from "./ProviderPage.vue?vue&type=script&lang=js"

import "./ProviderPage.vue?vue&type=style&index=0&id=090e499e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090e499e"]])

export default __exports__